import { Component, ContentChild, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ViewChild } from '@angular/core';
import { NarrowSidebarNavListComponent } from '../narrow-sidebar-nav-list/narrow-sidebar-nav-list.component';
import { IconModule } from '../../../icon/icon.module';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NarrowSidebarLogoDirective } from '../../directives/narrow-sidebar-logo.directive';

@Component({
  selector: 'app-narrow-sidebar-layout',
  imports: [RouterLink, RouterLinkActive, IconModule],
  templateUrl: './narrow-sidebar-layout.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NarrowSidebarLayoutComponent {
  // Views
  @ContentChild(NarrowSidebarLogoDirective) logo?: NarrowSidebarLogoDirective;
  @ContentChild(NarrowSidebarNavListComponent) navList?: NarrowSidebarNavListComponent;
  @ViewChild('elDialog') elDialog?: ElementRef<any>;

  hideMobileSidebar() {
    this.elDialog?.nativeElement.hide();
  }
}
